import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import styled from 'react-emotion';
import { css } from 'emotion';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import _ from 'lodash';
import cuid from 'cuid';

import { Label as BaseLabel } from '~/modules/coreUI/components/basic/Labels';
import Modal, { ModalContent } from '~/modules/core/components/Modal/index';
import Panel from '~/modules/accountManagement/components/basic/Panel';
import { LargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';

const Container = styled.div`
  padding-right: ${props => props.theme.paddings.large}px;
  padding-left: ${props => props.theme.paddings.large}px;

  ${(props => !(props.media.desktop || props.media.largeDesktop))
    && css`
      width: 100%;
    `};
`;

const Header = styled.tr`
  height: 42px;
  background-color: ${props => props.theme.colors.primary};
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  tr:first-child {
    th:first-child {
      border-top-left-radius: ${props => props.theme.borders.radius.normal}px;
    }
    th:last-child {
      border-top-right-radius: ${props => props.theme.borders.radius.normal}px;
    }
  }
`;

const HeaderLabel = styled(BaseLabel)`
  padding-right: ${props => props.theme.paddings.xxxxxLarge}px;
  padding-left: ${props => props.theme.paddings.xxxxxLarge}px;
  padding-top: ${props => props.theme.paddings.xLarge}px;
  padding-bottom: ${props => props.theme.paddings.xLarge}px;

  font-size: ${props => props.theme.fonts.sizes.medium}px;
  font-weight: ${props => props.theme.fonts.weights.semiBold};
  letter-spacing: 0.4px;
  color: ${props => props.theme.colors.named.white};
`;

const TDLabel = styled(BaseLabel)`
  padding-right: ${props => props.theme.paddings.xxxxxLarge}px;
  padding-left: ${props => props.theme.paddings.xxxxxLarge}px;
  padding-top: ${props => props.theme.paddings.xLarge}px;
  padding-bottom: ${props => props.theme.paddings.xLarge}px;

  font-size: ${props => props.theme.fonts.sizes.small}px;
  font-weight: ${props => (props.first ? 600 : 'normal')};
`;

const TD = styled.td`
  height: 42px;
  background-color: ${props => (props.first ? props.theme.colors.named.extraLightGrey : props.theme.colors.invertedLabels.hint)};
  text-align: center;

  border-width: ${props => props.theme.borders.size.thin}px;
  border-style: solid;
  border-color: #edebeb;
`;

const TH = styled.th`
  text-align: center;
`;

const SizeChartModalContent = styled(ModalContent)`
  width: 100%;
`;

class SizeChart extends Component {
  state = {
    sizeChartShown: false,
  };

  componentDidMount = () => {
    this.props.onRef(this);
  };

  show = () => {
    this.setState({
      sizeChartShown: true,
    });
  };

  render = () => {
    const { sizeChartShown } = this.state;
    const { sizeChart, media } = this.props;

    if (sizeChartShown) {
      return (
        <Modal onCloseRequested={() => this.setState({ sizeChartShown: false })}>
          <SizeChartModalContent>
            <Panel titleLabel="Size Chart" subTitleLabel="Choose your size" panelWidth="100%">
              <Container media={media}>
                {media.desktop || media.largeDesktop ? (
                  <Table>
                    <tbody>
                      {sizeChart
                        && sizeChart.map(
                          (chart, i) => (i === 0 ? (
                            <Header key={cuid()}>
                              {chart.metric.map(metric => (
                                <TH key={cuid()}>
                                  <HeaderLabel>{metric}</HeaderLabel>
                                </TH>
                              ))}
                            </Header>
                          ) : (
                            <tr key={cuid()}>
                              {chart.metric.map((metric, idx) => (
                                <TD key={cuid()} first={idx === 0}>
                                  <TDLabel first={idx === 0}>{metric}</TDLabel>
                                </TD>
                              ))}
                            </tr>
                          )),
                        )}
                    </tbody>
                  </Table>
                ) : (
                  <Fragment>
                    {_.drop(sizeChart, 1).map(chart => (
                      <Fragment key={cuid()}>
                        <Table>
                          <tbody>
                            {chart.metric.map(
                              (metric, i) => (i === 0 ? (
                                <Header key={cuid()}>
                                  <TH>
                                    <HeaderLabel>{sizeChart[0].metric[0]}</HeaderLabel>
                                  </TH>
                                  <TH>
                                    <HeaderLabel>{metric}</HeaderLabel>
                                  </TH>
                                </Header>
                              ) : (
                                <tr key={cuid()}>
                                  <TD first>
                                    <TDLabel first>{sizeChart[0].metric[i]}</TDLabel>
                                  </TD>
                                  <TD>
                                    <TDLabel>{metric}</TDLabel>
                                  </TD>
                                </tr>
                              )),
                            )}
                          </tbody>
                        </Table>
                        <LargeSpacer />
                      </Fragment>
                    ))}
                    <LargeSpacer />
                  </Fragment>
                )}
              </Container>
            </Panel>
          </SizeChartModalContent>
        </Modal>
      );
    }
    return null;
  };
}

SizeChart.defaultProps = {
  sizeChart: null,
};

SizeChart.propTypes = {
  sizeChart: PropTypes.arrayOf(PropTypes.any),
  media: PropTypes.shape().isRequired,
  onRef: PropTypes.func.isRequired,
};

export default withMedia(SizeChart);
